import { CURRENT_SERVICE_TYPE, SERVICE_TYPE } from '@utility/checkout-utils';

export const deDe = {
  ACCESS_DENIED: 'Zugriff verweigert.',
  ACCOUNT_SELECTION_VIEW_TITLE: 'Kontenauswahl',
  APPROVE_YOUR_PAYMENT_IN_APP: 'Bitte authentifizieren Sie die $t(SUBJECT)',
  AUTHENTICATION_METHOD: 'Authentifizierung',
  AUTHENTICATION_METHOD_VIEW_TITLE: 'Authentifizierungsmethode',
  AWAITING_DECOUPLED_AUTHORISATION_VIEW_TITLE: 'Warten auf Autorisierung',
  CANCEL_PAYMENT: '$t(SUBJECT) stornieren',
  CHIP_TAN_HEADER: 'chipTAN',
  CHIP_TAN_SUBHEADER: 'Nutze dein chipTAN-Gerät',
  CLOSE_CANCEL_MODAL: 'Stornierungsfenster für $t(SUBJECT) schließen',
  CODE_IS_NOT_WORKING: 'Der Code funktioniert nicht',
  CONFLICT: 'Konflikt.',
  CONTINUE: 'Weiter',
  CONTINUE_TO_YOUR_BANK: 'Weiter zu Ihrer Bank',
  HIDE_PASSWORD: 'Passwort / PIN ausblenden',
  I_DID_NOT_RECEIVE_CODE: 'Ich habe den Code nicht erhalten',
  I_DO_NOT_HAVE_MY_DEVICE: 'Ich habe mein Gerät nicht zur Hand',
  I_DO_NOT_REMEMBER_MY_BANK_CREDENTIALS:
    'Ich kann mich nicht an meine Anmeldedaten erinnern',
  I_WANT_TO_PAY_ANOTHER_WAY: 'Ich möchte auf eine andere Weise bezahlen',
  INTERNAL_SERVER_ERROR:
    'Etwas ist schiefgelaufen. Bitte wenden Sie sich an den Support.',
  LOADING_BANK_INFORMATION: 'Laden der Bankinformationen',
  LOG_IN: 'Anmelden',
  LOGIN_VIEW: 'Anmeldeansicht',
  LOGIN_VIEW_TITLE: 'Anmeldung',
  M_TAN_HEADER: 'mTAN',
  M_TAN_SUBHEADER: 'Empfange deine TAN per SMS',
  MASKED_IBAN_ACCESSIBLE:
    'Maskierte IBAN beginnend mit {{prefix}} und endend mit {{suffix}}',
  MY_AUTHENTICATION_METHOD_IS_NOT_DISPLAYED:
    'Meine Authentifizierungsmethode wird nicht angezeigt',
  MY_BANK_ACCOUNT_IS_NOT_DISPLAYED: 'Mein Bankkonto wird nicht angezeigt',
  NETWORK_ERROR:
    'Verbindungsfehler. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  OOPS_IT_APPEARS_THERE_IS_AN_ISSUE:
    'Es scheint ein Problem aufgetreten zu sein. Bitte laden Sie die Seite neu.',
  OPEN_CANCEL_MODAL: 'Stornierungsfenster für $t(SUBJECT) öffnen',
  OTHER: 'Andere',
  PAGE_LOADING: 'Seite wird geladen - bitte warten.',
  PASSWORD: 'Passwort',
  PAYING_WITH: 'Bezahlen mit',
  PHOTO_OTP_CHALLENGE_IMAGE_DESCRIPTION:
    'Photo-OTP (Einmalpasswort) Code-Grafik',
  PHOTO_OTP_FALLBACK_IMAGE_DESCRIPTION:
    'Wir konnten Ihren Bildcode nicht anzeigen. Bitte aktualisieren Sie die Seite oder stornieren Sie die $t(SUBJECT).',
  PHOTO_TAN_HEADER: 'photoTAN',
  PHOTO_TAN_SUBHEADER: 'Scanne eine Graphik mit deiner App oder deinem Reader',
  PLEASE_USE_SAME_LOGIN_DETAILS:
    'Bitte verwenden Sie dieselben Anmeldedaten, die Sie auch in der App oder auf der Website Ihrer Bank nutzen würden.',
  PROVIDE_VALID_LOGIN_DETAILS_TO_CONTINUE:
    'Geben Sie gültige Anmeldedaten ein, um fortzufahren',
  PROVIDE_VALID_VERIFICATION_CODE_TO_CONTINUE:
    'Geben Sie einen gültigen Code ein, um fortzufahren',
  PUSH_TAN_HEADER: 'pushTAN',
  PUSH_TAN_SUBHEADER: 'Authentifizierung via App',
  REDIRECT_OTP_HEADER: 'Redirect',
  REDIRECT_OTP_SUBHEADER:
    'Sie werden auf eine sichere Seite weitergeleitet, um Ihren Einmal-Code zu erhalten.',
  REDIRECT_VIEW_TITLE: 'Weiterleitung',
  RESOURCE_NOT_FOUND: 'Ressource nicht gefunden.',
  RESOURCE_NOT_MODIFIABLE:
    'SCA-Anmeldedaten für nicht eingebettete $t(SUBJECT) angegeben.',
  RETRY_LIMIT_EXCEEDED:
    'Das Limit für Wiederholungsversuche wurde erreicht. SCA fehlgeschlagen.',
  SCAN_CODE_WITH_YOUR_APP:
    'Scannen Sie die Grafik in der App Ihrer Bank und geben Sie den Code hier ein.',
  SELECT_ACCOUNT: 'Wählen Sie Ihr Konto aus',
  SELECT_AUTHENTICATION_METHOD: 'Authentifizierungsmethode auswählen',
  SELECT_AUTHENTICATION_METHOD_DISABLED_REASON:
    'Wählen Sie eine Authentifizierungsmethode aus, um fortzufahren',
  SELECTED_BANK_DETAILS: 'Ausgewählte Bankdaten',
  SHOW_PASSWORD: 'Passwort / PIN anzeigen',
  SOMETHING_WENT_WRONG: 'Etwas ist schiefgelaufen',
  SUBJECT: CURRENT_SERVICE_TYPE === SERVICE_TYPE.AIS ? 'Kontodaten' : 'Zahlung',
  SUBMIT_AND_CANCEL_PAYMENT: 'Absenden und $t(SUBJECT) stornieren',
  SUBMITTING_CANCEL: 'Abbrechen – Bitte warten',
  SUBMITTING_LOGIN: 'Anmeldung läuft - Bitte warten.',
  SUBMITTING_VERIFICATION_CODE:
    'Authentifizierungscode wird übermittelt - Bitte warten.',
  SUBMITTING_VERIFICATION_METHOD:
    'Verifizierungsmethode wird übermittelt - Bitte warten.',
  TAP_THE_PUSH_NOTIFICATION_FROM: 'Sie sollten eine Push-Mitteilung erhalten.',
  TO_IMPROVE_YOUR_NEXT_EXPERIENCE:
    'Würden Sie uns den Grund ihrer Stornierung mitteilen, damit wir unser Nutzererlebnis verbessern können?',
  UNAUTHORISED_LOGIN:
    'Die angegebenen Anmeldedaten für die Institution sind ungültig.',
  UNAUTHORISED_VERIFICATION: 'Der angegebene SCA-Code ist ungültig.',
  USER: 'Anmeldename',
  VERIFICATION_CODE: 'Verifizierungscode',
  VERIFICATION_VIEW_TITLE: 'Verifizierung',
  VERIFY: 'Verifizieren',
  VERIFY_PAYMENT: '$t(SUBJECT) verifizieren',
  VOLT_SCA: 'Volt SCA',
  WAITING_FOR_VERIFICATION_VIEW_TITLE: 'Warten auf Verifizierung',
  WAITING_FOR_VERIFY_STATUS:
    'Warten auf Verifizierungsstatus und Weiterleitung',
  YOUR_CODE_IS_DISPLAYED_IN_PUSHTAN_APP:
    'Ihr Code wird in Ihrer PushTAN-App oder in einer SMS angezeigt.',
} as const;
